export default {
  siteName: '管理后台',
  copyright: `COPYRIGHT &copy; ${new Date().getFullYear()} Eyas, All rights Reserved`,
  maker: '木公制作',
  backToHome: '返回首页',
}